export default "__VITE_ASSET__Gzq1y6ez__"